import { string, object } from 'yup';

const schema = object().shape({
  id: string().required('requiredField').max(26, 'tracking.codeMustBeAtMostCharacters')
});

export default schema;